import { createApp } from "vue";
import App from "./App.vue";

import Toast, { PluginOptions } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options: PluginOptions = {
  // You can set your default options here
};

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
// import router from "./router";
import router from "@/router/clean";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

//imports for app initialization
// import MockAdapter from "@/core/mock/MockService";
import ApiService from "@/core/services/ApiService";
// import ApiStrapiService from "@/core/services/ApiStrapiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import {
  companyTerminology,
  loadCompanyTerminologyConfig,
  syncCompanyTerminologyFromStorage,
} from "@/core/helpers/companyTerminology";

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";

// import CKEditor from "ckeditor4-vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
// const app = createApp(App)
// import "leaflet/dist/leaflet.css";
// import "vue3-form-wizard/dist/style.css";

const app = createApp(App);
app.config.globalProperties.$companyTerminology = companyTerminology;
syncCompanyTerminologyFromStorage();
loadCompanyTerminologyConfig();
router.afterEach(() => {
  syncCompanyTerminologyFromStorage();
});

app.use(store);
app.use(router);
app.use(ElementPlus);
app.component('Loading', Loading);

app.use(Toast, options);
app.use(CKEditor);
// app.use( CKEditor ).mount('#app');

ApiService.init(app);
// ApiStrapiService.init(app);
// MockAdapter.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
